<template>
    <div class="ilt-table-wrap">
        <div class="row">
            <div v-for="colIndex in chunk.length"
                 :key="colIndex"
                 class="col-3"
            >
                <div class="triangle-radio"
                     :class="{active: isOfferChecked(colIndex)}"
                     @click="onChangeSelectedOffer(colIndex)"
                >
                    <label class="inner-triangle"></label>
                </div>
            </div>
        </div>

        <ilt-table :offer="offer"/>
    </div>
</template>

<script>
import IltTable from './IltTable';

export default {
    components: {
        IltTable
    },

    props: {
        chunk: {
            type: Array,
            required: true
        },

        rowIndex: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            selectedColumnIndex: 0
        }
    },

    computed: {
        offer() {
            return this.chunk[this.selectedColumnIndex]
        }
    },

    methods: {
        isOfferChecked(colIndex) {
            return this.selectedColumnIndex === colIndex - 1
        },

        onChangeSelectedOffer(colIndex) {
            this.selectedColumnIndex = colIndex - 1
        }
    }
}
</script>
